<template>
  <div id="page_index">
    <div class="banner">
      <img src="../assets/img/index_banner.jpg" alt="" class="bg">
      <div class="textbox">
        <h1 class="wow fadeInLeft">Acoustic Solution Provider<br/>Of Sustainability And Innovation</h1>
        <p>Brotex is where technology, innovation and creativity converge, we aim to provide the best acoustic solution.</p>
      </div>
      <router-link to="./Product?cin=0" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
    </div>
    <div id="part1" class="full">
      <div class="mainTitle1 textbox">
        <h3>Company Advantage</h3>
        <p>As a leader in acoustic design solutions, we offering an expansive library of sound absorption products and accessory options. </p>
      </div>
      <div class="itembox">
        <div class="item wow flipInY" data-wow-delay=".1s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon1.png" alt="" class="icon">
          <h4>Focused On Research & Development</h4>
          <p>Brotex Technologies is always pushing the boundaries to implement new products & ideas.</p>
        </div>
        <div class="item wow flipInY" data-wow-delay=".2s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon2.png" alt="" class="icon">
          <h4>Our Value</h4>
          <p>At the heart of Brotex are our guiding values of Integrity, Respect, Collaboration, Excellence, and Leadership. These values support us as we deliver on our vision to be the top.</p>
        </div>
        <div class="item wow flipInY" data-wow-delay=".3s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon3.png" alt="" class="icon">
          <h4>After Service</h4>
          <p>Brotex wins the markets as the value of “Customer Comes First” with long-term friendly cooperation. We aim to provide you with a high standard after service, customer satisfaction is our goal.</p>
        </div>
        <div class="item wow flipInY" data-wow-delay=".4s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon4.png" alt="" class="icon">
          <h4>Leaders In Eco-Friendly Materials</h4>
          <p>Brotex is the leading sustainable product that fits within all projects and can supply its products to projects and job sites globally.</p>
        </div>
      </div>
    </div>
    <div id="part2">
      <div class="titlebox">
        <div class="mainTitle1 textbox">
          <h3>Main Categories</h3>
          <p>View our product catalog to get an acoustic rundown of our products and get what you want.</p>
        </div>
      </div>
      <div class="swpbox itembox">
        <swiper class="catswp" ref="swiper1" :options="catOpt" :auto-update='true'>
          <swiper-slide v-for="(item,index) in catList" :key="index">
            <router-link class="item" :to="{path:'./Product',query:{cin:index}}">
              <img :src="`${$https}${item.img}`" alt="">
              <p>{{item.name}}</p>
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination swppage1"></div>
      </div>
      <div class="btnbox">
        <router-link to="./Product?cin=0" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
      </div>
    </div>
    <div id="part3" class="full">
      <div class="bgcover"></div>
      <div class="bgbox" :style="{backgroundImage:`url(${swp1List[swp1Index].bg})`}"></div>
      <div class="mainTitle1 textbox white">
        <h3>Applications</h3>
        <p>Acoustics product applies to the environmental-demanding places.It shows the high grade public image and create a warm business entertainment and office atmosphere.</p>
      </div>
<!--      <router-link to="./Application" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>-->
      <div class="contentbox">
        <div class="tab_header">
          <div class="item" :class="index==swp1Index?'active':''" v-for="(item,index) in swp1List" :key="index" @click="swp1Index=index">{{item.title}}</div>
        </div>
        <div class="tab_content">
<!--          <img :src="swp1List[swp1Index].img" alt="" class="leftimg">-->
          <div class="textbox">
            <div class="line">
              <img :src="swp1List[swp1Index].icon" alt="">
              <h4>{{swp1List[swp1Index].title}}</h4>
            </div>
            <p>{{swp1List[swp1Index].text}}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="part4" class="full">
      <div class="mainTitle1 textbox">
        <h3>Service And Tech</h3>
      </div>
      <div class="contentbox">
        <div class="left">
          <p v-for="(item,index) in tabList[tabIndex].text" :key="index">{{item}}</p>
          <router-link to="./Service" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
        </div>
<!--        <div class="right">-->
<!--          <div class="item" :class="index==tabIndex?'active':''" v-for="(item,index) in tabList" :key="index" @click="tabIndex=index">{{item.title}}</div>-->
<!--          <div class="line"></div>-->
<!--        </div>-->
      </div>
    </div>
    <div id="part5">
      <div class="mainTitle1 textbox">
        <h3>Hot Sales</h3>
        <p>Check our star products, we make design happen.</p>
      </div>
      <div class="contentbox">
        <swiper class="swiper2" ref="swiper2" :options="swp2opt" :auto-update='true'>
          <swiper-slide v-for="(item,index) in hotList.slice(0,6)" :key="index">
            <router-link class="item" :to="{path:'./ProductInfo',query:{id:item.id,cin:0,}}">
              <div class="imgbox">
                <i class="triangle-topleft"></i>
                <img :src="`${$https}${item.img}`" alt="">
                <i class="triangle-topright"></i>
                <div class="cover"></div>
              </div>
              <p>{{item.name}}</p>
<!--              <div class="mainBtn2"><span>LEARN MORE</span><i>></i></div>-->
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination swppage2"></div>
      </div>
    </div>
<!--    <div class="slogan">-->
<!--      <h2>Welcome to ask for a question on improving your project visually and acoustically.</h2>-->
<!--      <router-link to="./Contact" class="mainBtn1 hbutton_isi">CONTACT US</router-link>-->
<!--    </div>-->
    <div id="part6" class="full">
      <div class="left">
        <div class="mainTitle1 textbox">
          <h3>About Brotex</h3>
<!--          <p>Brotex is a leader in acoustic design solutions, offering an expansive library of sound absorption products and accessory options. These utilize our sustainably sourced, 100% recyclable, lightweight and durable high-performance material. Brotex comes with a wide range of colors and finishes, including wood textures, with available customization, to help you achieve the look you need while you build noise reduction into your spaces.</p>-->
        </div>
        <img src="../assets/img/index_part6img.jpg" alt="">
        <p class="text1">Brotex is a leader in acoustic design solutions, offering an expansive library of sound absorption products and accessory options. These utilize our sustainably sourced, 100% recyclable, lightweight and durable high-performance material. Brotex comes with a wide range of colors and finishes, including wood textures, with available customization, to help you achieve the look you need while you build noise reduction into your spaces.</p>

        <router-link to="./Company" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
<!--        <div class="countbox">-->
<!--          <div class="item" v-for="(item,index) in countList" :key="index">-->
<!--            <countTo class="num" :startVal='item.start' :endVal='item.end' :duration='2000' separator=""></countTo>-->
<!--            <p>{{item.text}}</p>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
    <div id="part7" class="full">
      <div class="left">
        <div class="mainTitle1 textbox white">
          <h3>Our Certification</h3>
          <p>Certificates can not only prove our strength but also bring customers security and trust.In particular, Brotex's superior acoustic panels, ultra-microporous sound-absorbing panels, have obtained multiple certifications. With its high-quality aperture advantages and design, a Helmholtz resonance system is formed. The characteristics of high resistance and low perforation make the ultrasonic absorption coefficient of this series particularly excellent, reaching the top level in the industry.</p>
          <p>We are confident to manufacture more high-quality certified products so that you can buy and use them with certifications.</p>
        </div>
      </div>
      <div class="right">
        <swiper class="zsswp" ref="zsswp" :options="zhengshuOpt">
          <swiper-slide>
            <img src="../assets/img/首页-证书1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书3.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页证书4.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate3.jpg" alt="">
          </swiper-slide>
        </swiper>
      </div>
    </div>
    <div id="part8">
      <div class="titlebox">
        <div class="mainTitle1 textbox">
          <h3>Fresh News</h3>
          <p>Want to learn more about Brotex and the field of acoustics?Click to get them!</p>
        </div>
      </div>
      <div class="itembox">
        <router-link :to="{path:'./NewsInfo',query:{id:item.id}}" class="item" v-for="(item,index) in newsList" :key="index">
          <img :src="`${$https}${item.articleImg}`" alt="">
          <div class="bottom">
            <span>{{item.timelist}}</span>
            <h4>{{item.name}}</h4>
            <i>></i>
          </div>
        </router-link>
      </div>
      <router-link to="./News" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
    </div>
    <div id="comment" class="full">
      <div class="mainTitle1 textbox">
        <h3>Trusted By Our Customers</h3>
        <p>Let our customers to personally explain the use of our services and products.</p>
      </div>
      <div class="itembox">
        <swiper class="swiper1 swiper-no-swiping" ref="swipercom" :options="commentopt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item,index) in list" :key="index">
            <div class="imgbox">
              <img :src="item.img" alt="" class="head">
              <img src="../assets/img/comment_icon.png" alt="" class="icon">
            </div>
            <div class="right">
              <div class="line">
                <span>{{item.name}}</span>
                <el-rate class="rate" v-model="rate" disabled></el-rate>
              </div>
              <p>{{item.text}}</p>
            </div>
          </swiper-slide>
        </swiper>
<!--        <div class="swiper-button-prev sbp2" slot="button-prev"></div>-->
<!--        <div class="swiper-button-next sbn2" slot="button-next" ref="swpcomnext"></div>-->
      </div>
    </div>
  </div>
</template>

<script>
import {WOW} from 'wowjs'
import * as $request from "../api/index";
// import comment from "../components/comment";
// import countTo from 'vue-count-to';
export default {
  name: "Index",
  metaInfo:{
    title:'Guangdong Brotex Acoustic Technology Co.,Ltd | Home',
  },
  components: {
    // comment,
    // countTo,
  },
  data(){
    return{
      rate:5,
      list:[
        {
          img:require('../assets/img/comment_img1.jpg'),
          name:'Laura , the United States',
          text:'Since installing Brotex products, the sonic difference has been really astounding in our concert hall. It was a really great auditory experience.',
        },
        {
          img:require('../assets/img/comment_img2.jpg'),
          name:'Ella , HK of China',
          text:'We are delighted to work with Brotex Acoustics. Their products and expertise have allowed us to set up one of our studios very quickly and with great results. ',
        },
        {
          img:require('../assets/img/comment_img3.jpg'),
          name:'Jimmy , UAE',
          text:'The perforated acoustic panels of Brotex are really good materials and look. They clean up all the extra reverb in the room, and we didn\'t need to fill the whole room with them.',
        },
        {
          img:require('../assets/img/comment_img4.jpg'),
          name:'Peter , the United States',
          text:'Our panels arrived on time without any delay. Thank you very much for completing such a large order perfectly. Looking forward to our next cooperation!',
        },
      ],
      commentopt:{
        direction: 'vertical',
        slidesPerView: 3,
        spaceBetween: 10,
        slidesPerColumnFill:'row',
        navigation: {
          nextEl: '.sbn2',
          prevEl: '.sbp2'
        },
      },
      zhengshuOpt:{
        slidesPerView: 3,
        spaceBetween: 10,
      },
      catList:[
        {
          id:0,
          img:require('../assets/img/index_part2img1.jpg'),
          name:'Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_part2img2.jpg'),
          name:'Grooved Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_part2img3.jpg'),
          name:'Wood Wool Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_part2img4.jpg'),
          name:'Fabric Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_part2img5.jpg'),
          name:'Metal Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_part2img6.jpg'),
          name:'Art Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_part2img7.jpg'),
          name:'Melamine Acoustic Foam',
        },
      ],
      catOpt:{
        slidesPerView: 2,
        slidesPerColumn: 2,
        spaceBetween: 10,
        slidesPerColumnFill:'row',
        pagination: {
          el: '.swppage1',
          clickable:true,
        },
      },
      swp1Index:0,
      swp1List:[
        {
          bg:require('../assets/img/application_bg1_m.jpg'),
          title:'Office',
          text:'Brotex develops different strategies for various challenges and develops personalized configurations to optimize problem-solving based on the function and design of the office space. ',
          icon:require('../assets/img/index_part3icon1.png'),
          img:require('../assets/img/office2.jpg'),
        },
        {
          bg:require('../assets/img/application_bg2_m.jpg'),
          title:'School',
          text:'Brotex has a great number of successfully completed projects, both in purposed and multifunctional halls, which you can see here. For further information get in touch for a consultation with our specialists.',
          icon:require('../assets/img/index_part3icon2.png'),
          img:require('../assets/img/school4.jpg'),
        },
        {
          bg:require('../assets/img/application_bg3_m.jpg'),
          title:'Auditorium',
          text:'Brotex provides acoustic solutions for auditorium, including dedicated halls and multi-function auditorium, to provide you with the best sound quality.',
          icon:require('../assets/img/index_part3icon3.png'),
          img:require('../assets/img/theater1.jpg'),
        },
        {
          bg:require('../assets/img/application_bg4_m.jpg'),
          title:'Commercial',
          text:'Brotex is an expert in permanently solving noise problems. There are different professional methods for reducing noise on the walls, and ceilings of commercial places. ',
          icon:require('../assets/img/index_part3icon4.png'),
          img:require('../assets/img/hall1.jpg'),
        },
        {
          bg:require('../assets/img/application_bg5_m.jpg'),
          title:'Indoor Stadium',
          text:'Brotex provides many successful cases for indoor stadiums and gymnasiums, for further information, click and learn more.',
          icon:require('../assets/img/index_part3icon5.png'),
          img:require('../assets/img/indoor1.jpg'),
        },
        // {
        //   bg:require('../assets/img/application_bg2.jpg'),
        //   title:'Cinema',
        //   text:'Brotex designs active and passive noise control systems for the cinema space. If you need to provide solutions for your cinema, you can contact us.',
        //   icon:require('../assets/img/index_part3icon1.png'),
        //   img:require('../assets/img/cinema1.jpg'),
        // },
      ],
      tabIndex:0,
      tabList:[
        {
          title:'Technology',
          text:[
            'Creativity, expert knowledge, and cutting-edge technology shape everything we do—whether it’s exploring form and function in our growing range of acoustic products, adapting our customized solution to meet project needs.',
            'Our team is fully committed to preserving your project\'s core intent and bringing your vision to life.combining cutting-edge technology and software with a deep understanding of design to push the boundaries of acoustics.',
          ],
        },
        {
          title:'After Sale',
          text:[
            'Creativity, expert knowledge, and cutting-edge technology shape everything we do—whether it’s exploring form and function in our growing range of acoustic products, adapting our customized solution to meet project needs.',
            'Our team is fully committed to preserving your project\'s core intent and bringing your vision to life.combining cutting-edge technology and software with a deep understanding of design to push the boundaries of acoustics.',
          ],
        },
        {
          title:'Customization',
          text:[
            'Creativity, expert knowledge, and cutting-edge technology shape everything we do—whether it’s exploring form and function in our growing range of acoustic products, adapting our customized solution to meet project needs.',
            'Our team is fully committed to preserving your project\'s core intent and bringing your vision to life.combining cutting-edge technology and software with a deep understanding of design to push the boundaries of acoustics.',
          ],
        },
      ],
      hotList:[
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'1Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'2Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'3Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'4Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'5Perforated Acoustic Panel',
        },
        {
          id:0,
          img:require('../assets/img/index_hotimg1.jpg'),
          name:'6Perforated Acoustic Panel',
        },
      ],
      swp2opt:{
        slidesPerView: 2,
        slidesPerColumn: 3,
        spaceBetween: 10,
        slidesPerColumnFill:'row',
        pagination: {
          el: '.swppage2',
          clickable:true,
        },
      },
      countList:[
        // {
        //   start:0,
        //   end:0,
        //   text:'Every space engages and impacts',
        // },
        // {
        //   start:0,
        //   end:0,
        //   text:'Every space engages and impacts',
        // },
        {
          start:0,
          end:0,
          text:'Factory Area',
        },
      ],
      newsList:[
        {
          id:0,
          img:require('../assets/img/index_part8img.jpg'),
          name:'Want to learn more about Brotex and the field of acoustics?',
          time:'30 July  2020',
        },
        {
          id:0,
          img:require('../assets/img/index_part8img.jpg'),
          name:'Want to learn more about Brotex and the field of acoustics?',
          time:'30 July  2020',
        },
        {
          id:0,
          img:require('../assets/img/index_part8img.jpg'),
          name:'Want to learn more about Brotex and the field of acoustics?',
          time:'30 July  2020',
        },
      ],
    }
  },
  created() {
    this.$emit('getnav',0)
    $request.getCats().then(res=>{
      res.forEach(val=>{
        if(val.name=='en'){
          this.catList=val.sonList
          // console.log(this.catList)
        }
      })
    })
    $request.gethotShops().then(res=>{
      this.hotList=res
      // console.log(this.hotList)
    })
    $request.getnews(1,3).then(res=>{
      this.newsList=res.datas
      this.newsList.forEach(val => {
        val.timelist=this.$date(val.releaseDate)
      })
      console.log(this.newsList)
    })
  },
  mounted() {
    this.$nextTick(()=>{
      let wow = new WOW({
        mobile:true,
        live:false
      })
      wow.init()
      let flag=true
      window.onscroll = ()=> {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTopo = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        // var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        // var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        //滚动条到底部的条件
        // console.log(scrollTopo)
        if (scrollTopo > 5200 && flag==true) {
          this.countList[0].end = 2000;
          // this.countList[1].end = 1996;
          // this.countList[2].end = 2000;
          // this.countList[3].end = 6;
          setTimeout(()=>{
            this.$refs.swpcomnext.removeAttribute('class','swiper-button-disabled')
            this.$refs.swpcomnext.setAttribute('class','swiper-button-next sbn2')
            // console.log(this.$refs.swpcomnext.classList);
          },200)
          flag=false
        }
      };
    })
  }
}
</script>

<style lang="less" scoped>
#page_index{
  .banner{background:url('../assets/img/index_bannerbg.png') no-repeat 0 100%/contain @main-c4;height: unset;position: relative;z-index: 1;padding: 0;overflow: hidden;padding: 1.1rem 5%;
    .bg{position: absolute;bottom: 0rem;right: -60%;border-radius: 100px 0 0 0;z-index: -1;width: 140%;height: 90%;}
    //.wave3d{position: absolute;left: 3%;bottom: 0;width: 50%;height: 50%;z-index: -2;}
    .textbox{
      h1{color: white;}
      p{font:.14rem/.20rem Poppins-Regular;color: white;margin: .2rem 0 .9rem;}
    }
  }
  #part1{background: @main-c3;
    .itembox{flex-wrap: wrap;
      .item{position: relative;width: calc(50% - .05rem);display: flex;flex-direction: column;align-items: center;color: @main-c2;background: white;padding: .2rem .1rem;
        z-index: 1;
        .bg{position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);z-index: -1;width: 80%;}
        .icon{width: .3rem;height: .3rem;object-fit: contain;}
        h4{text-align: center;margin: .1rem 0;}
        p{font: .12rem/.16rem Poppins-Regular;margin: 0 auto;text-align: center;}
        &:active{background: @main-c1;}
        &:not(:nth-last-child(-n+2)){margin-bottom: .1rem;}
      }
    }
  }
  #part2{
    .titlebox{display: flex;justify-content: space-between;align-items: center;
      //.mainTitle1{margin-bottom: 0;
        //h3:before{left: -5.5%;}
        //p{width: 60%;}
      //}
    }
    .itembox{justify-content: center;flex-wrap: wrap;position: relative;padding-bottom: .2rem;margin-bottom: .2rem;
      /deep/ .swiper-wrapper{width: 100%;}
      /deep/ .swiper-slide{height: unset;}
      .item{width: calc(25%);text-align: center;margin: 0;
        img{width: 100%;height: .9rem;object-fit: contain;border: 1px solid rgba(244,244,244,1);}
        p{font: .12rem Poppins-Medium;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;margin-top: .1rem;transition: .3s;
          &:after{content: '>';position: relative;top: 1px;margin-left: .1rem;}
        }
        &:hover{
          p{color: @main-c1;}
        }
        &:nth-last-child(-n+4){margin-bottom: 0;}
      }
      //.swppage1{bottom: -.1rem;
      //  /deep/ span{margin: 0 .02rem;background: @main-c4;opacity: .9;transform: scale(.8);
      //    &.swiper-pagination-bullet-active{width: 20px;border-radius: 20px;background: @main-c1;}
      //  }
      //}
    }
    .btnbox{display: flex;justify-content: center;}
  }
  #part3{position: relative;
    //*{transition: .6s;}
    .bgcover{background: linear-gradient(to bottom,rgba(0,0,0,.5),transparent);position: absolute;top: 0;left: 0;width: 100%;height: 4rem;z-index: -1;}
    .bgbox{position: absolute;top: 0;left: 0;width: 100%;height: 100%;z-index: -2;background-repeat: no-repeat;background-position: 50% 50%;background-size: 100%;}
    .contentbox{margin-top: 0px;
      .tab_header{display: flex;color: white;overflow-x: scroll;border-radius: 100px;background: @main-c4;
        //position: sticky;top: .55rem;
        .item{background: @main-c4;text-align: center;font: .14rem Poppins-SemiBold;padding: .1rem .15rem;cursor: pointer;position: relative;transition: .3s;white-space: nowrap;border-radius: 100px;
          &:before{opacity: 0;transition: .3s;content: " ";top: -7px;left: 50%;transform: translate(-50%,-50%);position: absolute;width: 0;height: 0;color: #fff;text-align: center;border-bottom: 14px solid white;
            border-left: 7px solid transparent;border-right: 7px solid transparent;z-index: 1;
          }
          //&:after{content: '>';position: absolute;top: 50%;transform: translate(-50%,-50%);margin-left: 10px;transition: .3s;transform-origin: 50% 50%;}
          &:hover,&.active{background: @main-c1;color: @main-c4;}
          &.active {
            &:before{opacity: 1;}
            &:after{transform: rotate(90deg);}
          }
          &:last-child{border: none;}
        }
      }
      .tab_content{padding: .15rem .2rem;background: white;display: flex;align-items: center;margin-top: 40vh;transition: .6s;
        //.leftimg{margin-right: 70px;width: 419px;height: 203px;object-fit: cover;}
        .textbox{width: calc(100%);
          .line{display: flex;align-items: flex-end;margin-bottom: .1rem;
            img{width: .3rem;height: .3rem;object-fit: contain;}
            h4{font-size:.16rem;margin-left: .15rem;}
          }
          p{margin-bottom: 0;}
        }
      }
    }
    //&:active{
    //  .mainTitle1,.contentbox{opacity: 0;}
    //}
  }
  #part4{background: url("../assets/img/index_part4bg.jpg") no-repeat 50% 50%/cover;color: white;
    .mainTitle1{
      h3{color: white;}
    }
    .contentbox{display: flex;justify-content: space-between;align-items: center;padding-left: 0.2rem;
      .left{width: 100%;
        p{color: white;width: 100%;font: .12rem/.16rem Poppins-Regular;}
        .mainBtn1{margin-top: .2rem}
      }
      .right{width: 25%;border-left: 2px solid #909196;display: flex;flex-direction: column;justify-content: space-between;position: relative;
        .item{font: 22px Poppins-Medium;padding: 30px 0px 30px 50px;margin-left: -4px;transition: .3s;
          //&.active{border-color: @main-c1;}
        }
        .line{position: absolute;width: 6px;height: 33.333333%;background: @main-c1;left: -4px;animation: moveDown 7s infinite;}
      }
    }
  }
  #part5{margin-bottom: .3rem;
    .contentbox{position: relative;display: flex;flex-direction: column;align-items: center;
      .swiper2{width: 100%;}
      .item{display: block;
        .imgbox{position: relative;overflow: hidden;
          .cover{position: absolute;opacity: 0;background: black;width: 100%;height: 100%;left: 0;top: 0;transition: .6s;}
          img{width: 100%;height: 1.2rem;object-fit: contain;border: 1px solid rgba(244,244,244,1);}
          .triangle-topleft{width: 0px;height: 0px;border-top: .2rem solid @main-c1;border-right: .2rem solid transparent;position: absolute;top: 0;left: -.2rem;transition: .6s;z-index: 2;}
          .triangle-topright{width: 0px;height: 0px;border-bottom: .2rem solid @main-c1;border-left: .2rem solid transparent;position: absolute;bottom: 0;right: -.2rem;transition: .6s;z-index: 2;}
        }
        p{font: .12rem Poppins-Medium;padding: .1rem 0 0;color: @main-c4;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;}
        .mainBtn2{margin-bottom: 20px;}
        &:active{
          *{transition: .6s;}
          .imgbox{
            .cover{opacity: .2;}
            .triangle-topleft{left: 0;}
            .triangle-topright{right: 0;}
          }
          .mainBtn2{width: auto;padding: 0 15px;background: @main-c1;border-color: @main-c1;
            span{transform: translateX(0%);position: relative;margin-right: 10px;opacity: 1;}
          }
        }
      }
    }
    .sbp2{left: -10%!important;}
    .sbn2{right: -10%!important;}
    .swppage2{bottom: -.2rem;}
  }
  .slogan{padding: 85px 280px;background: @main-c1;display: flex;align-items: center;justify-content: space-between;color: @main-c4;
    h2{width: 80%;}
    .mainBtn1{border-color: #2A2E43;
      &:hover{border-color: @main-c1;}
    }
  }
  #part6{background: #f5f5f5;display: flex;justify-content: space-between;
    .left{width: 100%;
      .mainTitle1{
        //h3:before{left: -7%;}
        p{width: 100%;}
      }
      img{width: 100%;height: 30vh;object-fit: cover;margin-bottom: .1rem;}
      .text1{font:0.12rem/0.16rem Poppins-Regular;margin-bottom: .1rem;color: @main-c5;padding:0 .2rem;}
      .countbox{padding: 30px 0 0;margin-top: 60px;
        .item{margin: 30px 0;
          .num{font: 60px Poppins-SemiBold;color: @main-c4;}
          p{font: 16px Poppins-Regular;color: #75808B;}
          &:nth-child(1){
            .num:after{content: '㎡';font-size: 30px;}
          }
        }
      }
    }
    //.right{width: 50%;}
  }
  #part7{background: @main-c4;display: flex;justify-content: space-between;align-items: center;position: relative;z-index: 1;flex-direction: column;
    .wave3d{position: absolute;right: 0%;top: 0;width: 50%;height: 100%;z-index: -1;}
    .left{width: 100%;
      .mainTitle1{margin: 0;
        //h3:before{left: -8%;}
        p{width: 100%;opacity: .6;}
      }
    }
    .right{display: flex;justify-content: space-between;margin-top: .15rem;width: 100%;
      img{width: calc(100%);height: 1.55rem;object-fit: cover;}
    }
  }
  #part8{
    .titlebox{display: flex;justify-content: space-between;align-items: center;margin-bottom: .2rem;
      .mainTitle1{margin-bottom: 0;
        //h3:before{left: -5.5%;}
        //p{width: 60%;}
      }
    }
    .itembox{flex-direction: column;
      .item{background: #F7F8FC;width: 100%;display: flex;margin-bottom: .1rem;align-items: center;
        img{width: 45%;height: 1rem;object-fit: cover;}
        .bottom{padding: .1rem;width: 55%;
          h4{color: @main-c4;
            //display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;
          }
          span{color: @main-c2;opacity: .6;font: .12rem Poppins-Regular;}
          i{font:.12rem Poppins-SemiBold;font-style: normal;position: relative;top: 2px;color: @main-c1;}
        }
        //&:hover{
        //  .bottom i{color: @main-c1;}
        //}
      }
    }
  }
  #comment{background: url("../assets/img/comment_bg.png") no-repeat 100% 0%/40% rgba(247,248,252);padding: .30rem 3%;
    /deep/ .swiper-slide{height: unset!important;}
    .itembox{display: flex;position: relative;
      .item{display: flex;align-items: center;background: white;padding: .1rem;
        .imgbox{position: relative;
          .head{border-radius: 50%;width: .5rem;height: .5rem;object-fit: cover;}
          .icon{position: absolute;bottom: 0%;right: -10%;width: .2rem;height: .2rem;}
        }
        .right{margin-left: .2rem;
          .line{display: flex;justify-content: space-between;align-items: baseline;
            &>span{font: .14rem Poppins-Medium;color: @main-c4;}
            .rate{
              /deep/ .el-rate__icon{font-size: .12rem;margin-right: .03rem;}
            }
          }
          p{font: .12rem/.18rem Poppins-Regular;color: #657788;}
        }
      }
    }
  }
}
</style>
<!--transition: transform .3s cubic-bezier(.645,.045,.355,1);transform: translateY(40px);-->